<div class="recent-orders">
    <div class="title-buttons">
        <strong>{{'sectors.label' | translate}}</strong>
    </div>
    <div class="table-responsive">
        <table class="table table-striped" id="my-orders-table">
            <thead>
            <tr class="first last">
                <th>{{'sectors.french_name' | translate}}</th>
                <th>{{'sectors.english_name' | translate}}</th>
                <th>
                    <button (click)="add_sector()"
                            class="button button-submit button-md"> {{'common.add' | translate}}
                    </button>
                </th>
            </tr>
            </thead>
            <tbody *ngIf="loading">
            <tr>
                <td colspan="3" style="text-align: center">{{'common.loading' | translate}} ...</td>
            </tr>
            </tbody>
            <tbody *ngIf="!loading">
            <tr *ngFor="let sector of sectors">
                <td>{{ sector.nameFr }}</td>
                <td>{{ sector.name }}</td>
                <td>
                       <span class="nobr">
                           <a (click)="edit_sector(sector)">{{'common.edit' | translate}}</a>
                           <span class="separator"> | </span>
                           <a (click)="delete_sector(sector)">{{'common.delete' | translate}}</a>
                       </span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="toolbar" *ngIf="!loading">
    </div>
</div>
